












import Vue from 'vue';    
import pdf from 'vue-pdf';
import store from '../store/store';
import { mapState } from 'vuex';

interface PdfData {
  pdfUrl: string,
  numPages: number
}

export default Vue.extend({
  name: 'Pdf',
  components: {
      pdf
  },
  data(): PdfData {
    return {
      pdfUrl: '/ja/信息与文献参考文献著录规则.pdf',
      numPages: 0 // pdf总页数
    };
  },
  computed: mapState({
    menuIsCollapse: (state: any) => store.getters.getMenuIsCollapse
  }),
  methods: {
      getNumPages() {
          let loadingTask = pdf.createLoadingTask(this.pdfUrl);
          loadingTask.promise.then((pdff: any) => {
              this.numPages = pdff.numPages;
          }).catch((err: any) => {
              console.error('pdf 加载失败', err);
          })
      }
  },
  mounted() {
      this.$store.dispatch('setMenuIsCollapse',  true);
      this.getNumPages();
  }
});
